import React from 'react'
import Navbar from '../../Components/Navbar';
import '../UXcasestudies/FirstVoices.css';

const FiirstVoicess = () => {
    return (
        <div>
            <Navbar />

            <div className='FVContainer'>

            
                
                <h2>
                    FirstVoices 

                </h2>
                
                
                <p>
                    FirstVoices is a collaborative platform where 
                    Indigenous communities manage, curate and share their 
                    languages. 
                </p> 
            





            {/* FVContainer ends below */}
            </div>      
            
        </div>
    )
}

export default FiirstVoicess

